module.exports = __webpack_public_path__ + "static/media/Trace-Bot-Processing.80d19aa2.svg";